// extracted by mini-css-extract-plugin
export default {"centerLoader":"Page_centerLoader__sLQO4","placeholderText":"Page_placeholderText__iTj1t","profileCompletionBox":"Page_profileCompletionBox__0f3IJ"};